var map = {
	"./article-image": 7,
	"./article-image.jpg": 7,
	"./ballet": 8,
	"./ballet.jpg": 8,
	"./children": 9,
	"./children.jpg": 9,
	"./cover-image": 10,
	"./cover-image.jpg": 10,
	"./creatives-banner": 11,
	"./creatives-banner.png": 11,
	"./faq-hero": 12,
	"./faq-hero.jpg": 12,
	"./header-logo": 13,
	"./header-logo.svg": 13,
	"./hero": 14,
	"./hero.jpg": 14,
	"./legs": 15,
	"./legs.jpg": 15,
	"./principal": 3,
	"./principal.jpg": 43,
	"./principal.png": 3,
	"./slide-image": 16,
	"./slide-image.jpg": 16,
	"./spotlight-bg": 4,
	"./spotlight-bg.jpg": 44,
	"./spotlight-bg.png": 4,
	"./stage-show": 17,
	"./stage-show.jpg": 17,
	"./studio": 18,
	"./studio.jpg": 18,
	"./symbols/arrow": 19,
	"./symbols/arrow.svg": 19,
	"./symbols/bg-logo": 20,
	"./symbols/bg-logo.png": 20,
	"./symbols/burger": 21,
	"./symbols/burger.svg": 21,
	"./symbols/calendar": 22,
	"./symbols/calendar.svg": 22,
	"./symbols/check": 23,
	"./symbols/check.svg": 23,
	"./symbols/colchester-new-logo": 24,
	"./symbols/colchester-new-logo.png": 24,
	"./symbols/cross": 25,
	"./symbols/cross.svg": 25,
	"./symbols/email": 26,
	"./symbols/email.svg": 26,
	"./symbols/facebook-social": 5,
	"./symbols/facebook-social.jpg": 45,
	"./symbols/facebook-social.svg": 5,
	"./symbols/favicon": 27,
	"./symbols/favicon.svg": 27,
	"./symbols/instagram-social": 28,
	"./symbols/instagram-social.svg": 28,
	"./symbols/instagram-white": 29,
	"./symbols/instagram-white.svg": 29,
	"./symbols/logo": 30,
	"./symbols/logo.svg": 30,
	"./symbols/new-logo-horizontal": 31,
	"./symbols/new-logo-horizontal.svg": 31,
	"./symbols/phone": 32,
	"./symbols/phone.svg": 32,
	"./symbols/pin": 33,
	"./symbols/pin.svg": 33,
	"./symbols/signature": 34,
	"./symbols/signature.svg": 34,
	"./timetable-image": 35,
	"./timetable-image.jpg": 35
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;